export const PROD_HUB_BASE_URL = "https://hub.memorang.com";
export const LOCAL_HUB_BASE_URL = "http://localhost:3000";
